import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { pricing } from '../data/content';
export function Pricing() {
  return <section id="pricing" className="w-full border-t border-line bg-ink py-24 lg:py-32" data-id="element-122" data-mp="2aqsu52yal7n9">
      <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-123" data-mp="2oi7g9inhxoyj">
        <p className="display text-sm tracking-widest text-brand-red" data-id="element-124" data-mp="2jjw2wxxzswbk">{pricing.eyebrow}</p>
        <h2 className="display mt-3 max-w-2xl text-[clamp(2rem,4.4vw,3.25rem)] leading-[0.98] text-cream" data-id="element-125" data-mp="1vts3l2ru7iqd">
          {pricing.heading}
        </h2>

        <div className="mt-12 grid gap-6 lg:grid-cols-[minmax(0,1.15fr)_minmax(0,1fr)]" data-id="element-126" data-mp="1ru15edzze0bt">
          {pricing.plans.map(plan => <article key={plan.name} className={`flex h-full flex-col rounded-lg border p-8 lg:p-10 ${plan.featured ? 'border-brand-red bg-surface' : 'border-line bg-surface/60'}`} data-id="element-127" data-mp="25pv5q8movhdb">
              <h3 className="display text-xl tracking-wide text-cream" data-id="element-128" data-mp="3c7i82amvc90j">{plan.name}</h3>
              <p className="mt-5 flex items-baseline gap-2" data-id="element-129" data-mp="3vyf4ql3c4nyo">
                <span className={`display text-[clamp(2.75rem,6vw,4rem)] leading-none ${plan.featured ? 'text-brand-red' : 'text-cream'}`} data-id="element-130" data-mp="4t5mjfll1dzm">
                  {plan.price}
                </span>
                <span className="text-sm text-cream/55" data-id="element-131" data-mp="eqk27czolyqv">{plan.cadence}</span>
              </p>
              <p className="mt-4 text-base leading-relaxed text-cream/70" data-id="element-132" data-mp="3daigzee3kofa">{plan.body}</p>

              <ul className="mb-9 mt-7 space-y-3" data-id="element-133" data-mp="3i8tr7q8b10y1">
                {plan.features.map(feature => <li key={feature} className="flex items-start gap-3 text-sm text-cream/80" data-id="element-134" data-mp="3n5kaemfeocno">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-green" aria-hidden="true" data-id="element-135" data-mp="3rzepfck2g3gf" />
                    {feature}
                  </li>)}
              </ul>

              <a href="#top" className={`group mt-auto inline-flex items-center justify-center gap-2 rounded-md px-6 py-4 text-sm font-semibold transition-colors duration-150 ease-out ${plan.featured ? 'bg-brand-red text-white hover:bg-brand-redDark' : 'border border-line text-cream hover:border-cream/40 hover:bg-white/5'}`} data-id="element-136" data-mp="2zg9f3kgtragx">
                {plan.cta}
                <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-137" data-mp="28h7csznm9ydb" />
              </a>
            </article>)}
        </div>

        <p className="mt-6 text-sm text-cream/55" data-id="element-138" data-mp="2idtw3k0aohd8">{pricing.note}</p>
      </div>
    </section>;
}